import React from 'react';
import PropTypes from 'prop-types';

import { Alert } from 'reactstrap';
import { Link } from 'react-router-dom';

import {
  colors,
  cardStyle,
  smallCapsStyle,
  headingStyle,
  StepCard,
  ConnectedPill,
  PrimaryButton,
} from './ConnectionParts';

// Manual redemptions: same behaviour as before (the button sets companiesApiManual and the active type 'manual'
// through changeManualAPIData); only the layout follows the approved design.

const stepHeading = { ...headingStyle, fontSize: 18 };

const ManualConnection = ({ isOn, onTurnOn, busy, disabled, error }) => (
  <>
    <section style={cardStyle}>
      <h2 style={{ ...headingStyle, marginBottom: 10 }}>Redeem vouchers yourself</h2>
      <p style={{ margin: 0, fontSize: 16, lineHeight: 1.6, color: colors.muted }}>
        Choose Manual if you don't sell through Shopify or WooCommerce, or you take orders in person, by phone or by email. Steppr won't create codes in an online shop; you check and redeem each code in Steppr instead.
      </p>
    </section>

    <StepCard number={1}>
      <h3 style={stepHeading}>The customer gives you their voucher code</h3>
      <p style={{ margin: 0, fontSize: 15, color: colors.muted }}>In person, by phone or by email.</p>
    </StepCard>

    <StepCard number={2}>
      <h3 style={stepHeading}>Check and redeem it in Payments</h3>
      <p style={{ margin: 0, fontSize: 15, color: colors.muted }}>
        Search for the code in <Link to="/payments" style={{ color: colors.blue }}>Payments</Link>, check it's unused and in date, then mark it as redeemed so it can't be used again.
      </p>
    </StepCard>

    <StepCard number={3}>
      <h3 style={stepHeading}>Turn on manual redemptions</h3>
      <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 12 }}>
        <PrimaryButton onClick={onTurnOn} disabled={disabled || isOn} busy={busy}>
          Use manual redemptions
        </PrimaryButton>
        <span style={{ fontSize: 14, color: colors.muted }}>You can switch to Shopify or WooCommerce at any time.</span>
      </div>
      {error ? (<Alert color="danger" style={{ margin: 0 }}>{error}</Alert>) : null}
    </StepCard>

    {isOn ? (
      <>
        <p style={smallCapsStyle}>Manual redemptions</p>
        <section style={{ ...cardStyle, display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '16px 28px' }}>
          <ConnectedPill>Manual redemptions on</ConnectedPill>
          <span style={{ fontSize: 15, color: colors.muted }}>Redeem codes in Payments.</span>
          <Link to="/payments" style={{ marginLeft: 'auto', fontSize: 16, fontWeight: 600, color: colors.blue }}>Go to Payments</Link>
        </section>
      </>
    ) : null}
  </>
);

ManualConnection.propTypes = {
  isOn: PropTypes.bool,
  onTurnOn: PropTypes.func.isRequired,
  busy: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.node,
};

ManualConnection.defaultProps = {
  isOn: false,
  busy: false,
  disabled: false,
  error: null,
};

export default ManualConnection;
